import { UserAddOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import DealUpdateMenu from 'automations/components/Nodes/DealUpdateMenu/DealUpdateMenu';
import { type DealUpdateNodeType, nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type TriggerNodeReturnProps } from './useTriggerNodeConfig';

export default function useDealUpdate(node: NodeProps<DealUpdateNodeType>): TriggerNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.DealUpdateNodeData, node.data), [node.data]);
  const AdditionalUI = useMemo(() => <DealUpdateMenu node={node} />, [node]);

  return {
    icon: UserAddOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    AdditionalUI,
  };
}
